import { render, staticRenderFns } from "./RevisaoDadosBancarios.vue?vue&type=template&id=7192a1c0"
import script from "./RevisaoDadosBancarios.vue?vue&type=script&lang=js"
export * from "./RevisaoDadosBancarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports